import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ICheckForCardRequest, RequestMode } from '../../interfaces/ICheckForCardRequest.interface';
import { IDestinationCard, IStandingOrderData } from '../../interfaces/ICheckForCardResponse.interface';
import { DirectDebitService } from '../../services/direct-debit.service';
import { TransferModal } from './transfer-popup/constant.modal';
import { ModalService } from '../../../../shared/modules/bs-modal/services/modal.service';
import { IContentResponse } from '../../interfaces/IContentResponse.interface';
import { RoutingHistoryService, isNullOrUndefined } from 'core-max-lib';
import {
    IFromCard,
    ITransferOrderMaxAndForeignRequest
} from '../../interfaces/ITransferOrderMaxAndForeignRequest.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { GtmService } from '../../../../shared/cardholders-core/services/gtm.service';
import { LegalPopupModal } from '../popup-legal/constant.modal';
@Component({
    selector: 'app-destination-cards',
    templateUrl: './destination-cards.component.html',
    styleUrls: ['./destination-cards.component.scss']
})
export class DestinationCardsComponent implements OnInit, OnDestroy {
    currentDestCard: IDestinationCard;
    destCards: IDestinationCard[];
    regulations: string;
    chkRegulations = false;
    showErrorNoSelectedCard = false;
    showErrorMessage = false;
    showPickStandingOrderData = false;
    standingOrderData: IStandingOrderData[] = [];
    subs: Subscription[] = [];
    contents: IContentResponse;

    constructor(
        private directDebSrv: DirectDebitService,
        private modalSrv: ModalService,
        private router: Router,
        private activeRoute: ActivatedRoute,
        private gtmService: GtmService
    ) {}

    ngOnInit(): void {
        this.currentDestCard = this.directDebSrv.selectedDestCard;
        this.destCards = this.directDebSrv.checkForCardResponse.destinationCards;
        this.contents = this.directDebSrv.contents$.value;

        if (
            !isNullOrUndefined(
                this.directDebSrv.checkForCardResponse.checkForCards[0].cardResponse.standingOrderToMove
            ) &&
            this.directDebSrv.checkForCardResponse.checkForCards[0].cardResponse.standingOrderToMove.length > 0
        ) {
            this.directDebSrv.checkForCardResponse.checkForCards[0].cardResponse.standingOrderToMove.forEach(
                (element) => {
                    this.standingOrderData.push(element);
                }
            );
        }

        this.showPickStandingOrderData =
            !isNullOrUndefined(this.standingOrderData) && this.standingOrderData.length > 0;
        this.gtmService.pushDirectDebit('phase2', 'load');
        if (this.showPickStandingOrderData) {
            this.gtmService.pushDirectDebit('phase2', 'link-show');
        }
    }

    cardSelected(card: IDestinationCard): void {
        this.currentDestCard = card;
        this.showErrorNoSelectedCard = false;
        this.gtmService.pushDirectDebit('phase2', 'choose card');
    }

    chkRegulationsChange(): void {
        this.chkRegulations = !this.chkRegulations;
        this.showErrorMessage = !this.chkRegulations;
    }

    transferAllDirectDebits(): void {
        if (!this.chkRegulations) {
            this.showErrorMessage = true;
            return;
        }

        if (this.currentDestCard == null) {
            this.showErrorNoSelectedCard = true;
            return;
        }

        this.gtmService.pushDirectDebitWorkFlow('phase2', 'continue', '2');

        const standingOrderToMoveList: string[] = [];
        if (this.showPickStandingOrderData) {
            this.directDebSrv.checkForCardResponse.checkForCards[0].cardResponse.standingOrderToMove.forEach((x) =>
                standingOrderToMoveList.push(x.transactionID)
            );
        }

        const fromCard: IFromCard = {
            tokenRef: this.directDebSrv.checkForCardResponse.checkForCards[0].tokenRef,
            standingOrderToMove: standingOrderToMoveList
        };

        this.transfer(fromCard);
    }

    transferDirectDebits(): void {
        if (!this.chkRegulations) {
            this.showErrorMessage = true;
            return;
        }

        if (this.currentDestCard == null) {
            this.showErrorNoSelectedCard = true;
            return;
        }

        this.gtmService.pushDirectDebit('phase2', 'link-click');
        TransferModal.options.initialState = {
            transactions: this.standingOrderData
        } as Object;
        this.subs.push(
            this.modalSrv.openModal(TransferModal).subscribe((standingOrdersToMove) => {
                if (standingOrdersToMove) {
                    const standingOrderToMoveList: string[] = [];
                    if (this.showPickStandingOrderData) {
                        standingOrdersToMove.forEach((standingOrder) =>
                            standingOrderToMoveList.push(standingOrder.transactionID)
                        );
                    }
                    const fromCard: IFromCard = {
                        tokenRef: this.directDebSrv.checkForCardResponse.checkForCards[0].tokenRef,
                        standingOrderToMove: standingOrderToMoveList
                    };

                    this.transfer(fromCard);
                }
            })
        );
    }
    openRegulation(event: MouseEvent): void {
        event.stopPropagation();
        event.preventDefault();
        this.subs.push(this.modalSrv.openModal(LegalPopupModal).subscribe(() => {}));
    }
    transfer(fromCard: IFromCard): void {
        const req: ITransferOrderMaxAndForeignRequest = {
            tranferToCardIndex: this.currentDestCard.cardIndex,
            fromCard: [fromCard],
            isHokBebefit: this.directDebSrv.isHokBebefit
        };

        this.directDebSrv.transferDirectDebits(req).subscribe((res) => {
            switch (res.returnCode) {
                case 0:
                case 18:
                case 20:
                    this.directDebSrv.next = 'success';
                    this.router.navigate(['../success'], { relativeTo: this.activeRoute });
                    break;
                case 10:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 19:
                default:
                    this.directDebSrv.rcError = res.returnCode;
                    this.directDebSrv.fromError = 'Destination';
                    this.directDebSrv.next = 'error';
                    this.router.navigate(['../error'], { relativeTo: this.activeRoute });
                    break;
            }
        });
    }

    ngOnDestroy(): void {
        this.subs.map((s) => s.unsubscribe());
    }
}
